






























































import { Vue, Component, Prop } from "vue-property-decorator";
import DetailsEnterpriseInfoTab from "./DetailsEnterpriseInfoTab.vue";
import DetailsUserInfoTabs from "./DetailsUserInfoTab.vue";
import DetailsInstituteInfoTabs from "./DetailsInstituteInfoTab.vue";
import DetailsJobOffer from "./DetailsJobOffer.vue";
import DetailsStudentInfoTab from "./DetailsStudentInfoTab.vue";
import DetailsInfoRichiestaAlternanza from "./DetailsInfoRichiestaAlternanza.vue";
import DetailsInfoAlternanza from "./DetailsInfoAlternanza.vue";
import DetailsQuestionarioColloquio from "./DetailsQuestionarioColloquio.vue";
import DetailsRichiestaTirEstivo from "./DetailsRichiestaTirEstivo.vue";
import DetailsTirEstivo from "./DetailsTirEstivo.vue";
import DetailsRichiestaTirFormativo from "./DetailsRichiestaTirFormativo.vue";
import DetailsTirFormativo from "./DetailsTirFormativo.vue";
import DetailsReportVisita from "./DetailsReportVisita.vue";
import DetailsAttivita from "./DetailsAttivita.vue";
import DetailsContattoAzienda from "./DetailsContattoAzienda.vue";
import DetailsNotaAzienda from "./DetailsNotaAzienda.vue";
import DetailsApprendistato from "./DetailsApprendistato.vue";

@Component({
    components: {
        DetailsEnterpriseInfoTab,
        DetailsUserInfoTabs,
        DetailsInstituteInfoTabs,
        DetailsJobOffer,
        DetailsStudentInfoTab,
        DetailsInfoRichiestaAlternanza,
        DetailsInfoAlternanza,
        DetailsQuestionarioColloquio,
        DetailsRichiestaTirEstivo,
        DetailsTirEstivo,
        DetailsRichiestaTirFormativo,
        DetailsTirFormativo,
        DetailsReportVisita,
        DetailsAttivita,
        DetailsContattoAzienda,
        DetailsNotaAzienda,
        DetailsApprendistato
    }
})
export default class DetailsInfo extends Vue {
    @Prop() info!: object;
    @Prop() userType!: string;
    @Prop() detailsType!: string;
}
